// Single source of truth for the idle auto-logout.
//
// Change IDLE_TIMEOUT_MS here and BOTH the actual behaviour (Layout's
// useIdleTimeout) AND every piece of user-facing / legal copy that quotes the
// duration update together — the copy reads IDLE_TIMEOUT_MINUTES, so the stated
// value can never drift out of sync with what the app actually does.
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;   // auto sign-out after inactivity
export const IDLE_WARNING_MS = 60 * 1000;        // warn this long before sign-out

/** Whole minutes of inactivity before auto sign-out, for display in copy. */
export const IDLE_TIMEOUT_MINUTES = Math.round(IDLE_TIMEOUT_MS / 60_000);
